import ApplicationController from './application_controller'

class SidenavController extends ApplicationController {
  static targets = ['eventTab']

  eventTabTargetConnected (elm) {
    $(elm).on('click', (e) => {
      const tabTarget = e.target.dataset.bsTarget.replace('#', '')
      window.history.pushState(null, tabTarget, window.location.pathname + `?${$.param({ collection: tabTarget })}`)
      Array.from(this.eventTabTargets).forEach((el) => {
        el.classList.remove('active')
      })

      document.querySelectorAll('.candidate-events-nav li, li.candidate-events-nav').forEach((el) => {
        el.classList.remove('active')
        el.childNodes[0]?.classList?.remove('active')
      })

      document.querySelectorAll(`a[data-bs-target="#${tabTarget}"]`).forEach((el) => {
        el.parentElement.classList.add('active')
      })

      const eventList = document.querySelectorAll('#candidate_events, #employee_events')
      Array.from(eventList).forEach((el) => {
        el.innerHTML = ''
        el.classList.add('block', 'skeleton')
      })
    })
  }
}

export default SidenavController
